import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.privacyTerms,
	components: () => [import(/* webpackChunkName: 'privacyTerms' */ './component')],
	render: ([PrivacyTerms]) => <PrivacyTerms />,
};

export default routes;
